module.exports = __webpack_public_path__ + "static/california-5e370052c58da27cd0e5d1de631a2cb0.jpg";